
import { MainLayout } from "@/components/layout/MainLayout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useState } from "react";
import { QADialog } from "./QADialog";
import { toast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

export default function QA() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleAddQA = async (question: string, answer: string, category: string) => {
    setIsSubmitting(true);
    try {
      // Add to Supabase using type assertion
      const response = await (supabase as any)
        .from('qa_items')
        .insert([
          {
            question,
            answer,
            category,
            // New submissions from members are inactive until approved
            is_active: false
          }
        ]);
        
      if (response.error) {
        throw response.error;
      }
      
      // Show success message
      toast({
        title: "Επιτυχία",
        description: "Η ερώτηση και απάντηση προστέθηκε επιτυχώς! Θα είναι διαθέσιμη μετά την έγκριση από το διαχειριστή."
      });
      setDialogOpen(false);
    } catch (error) {
      console.error("Error adding Q&A item:", error);
      toast({
        title: "Σφάλμα",
        description: "Υπήρξε πρόβλημα κατά την αποθήκευση της ερώτησης & απάντησης.",
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">Q&A</h1>
          <Button onClick={() => setDialogOpen(true)} className="flex items-center gap-1" disabled={isSubmitting}>
            <PlusCircle className="h-4 w-4" />
            <span>Προσθήκη Q&A</span>
          </Button>
        </div>
        
        <p className="text-muted-foreground">
          Ερωτήσεις και απαντήσεις για τα μέλη της Web Star. Επιλέξτε μια από τις κατηγορίες στα αριστερά.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="border rounded-lg p-6 hover:bg-accent transition-colors">
            <h2 className="text-xl font-semibold mb-2">Ερωτήσεις</h2>
            <p className="text-sm text-muted-foreground mb-4">Συχνές ερωτήσεις και απαντήσεις για τεχνικά θέματα.</p>
            <Link to="/qa/questions" className="text-primary hover:underline">Δείτε όλες τις ερωτήσεις →</Link>
          </div>
          <div className="border rounded-lg p-6 hover:bg-accent transition-colors">
            <h2 className="text-xl font-semibold mb-2">Φόρουμ Συζητήσεων</h2>
            <p className="text-sm text-muted-foreground mb-4">Συζητήσεις μεταξύ των μελών της κοινότητας.</p>
            <Link to="/qa/forum" className="text-primary hover:underline">Επισκεφθείτε το φόρουμ →</Link>
          </div>
        </div>
      </div>
      
      <QADialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        onSubmit={handleAddQA}
      />
    </MainLayout>
  );
}
